<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      class=""
      :bordered="false"
      :padding="0"
      >
      <p slot="title">
        代理管理
      </p>
    </Card>
      <div class="content">
        <Card
          class="smy__card-full card-left"
          :bordered="false"
          >
          <AgencyManageLeft
          :accountList="accountList"
          />
        </Card>
        <div
          class="smy__card-full card-right"
          >
          <Card
          :bordered="false"
           style="margin-bottom:10px">
          <AgencyManageTop
          :accountList="accountList"
          @callback="loadList()"
          />
        </Card>
        <Card
        :bordered="false"
        >
          <AgencyManageRight
            ref="orderDetailRight"
            :accountList="accountList"
            :updataList="updataList"
          />
        </Card>
      </div>
      </div>
  </div>
</template>

<script>
import AgencyManageLeft from './AgencyManageLeft'
import AgencyManageTop from './AgencyManageTop'
import AgencyManageRight from './AgencyManageRight'

export default {
  components: {
    AgencyManageLeft,
    AgencyManageTop,
    AgencyManageRight
  },
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      updataList: [],
      accountList: {}
    }
  },
  methods: {
    loadList () {
      this.listLoading = true
      this.$http.get('/agent/account/info', {
        params: {
          id: this.orderId
        }
      }).then(res => {
        this.accountList = res.data
        this.listLoading = false
      })
      this.$http.get('/agent/account/update/list', {
        params: {
          id: this.orderId
        }
      }).then(res => {
        this.updataList = res.data
        this.listLoading = false
      })
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  display: flex;
  .card-left {
    width: 300px;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agencyManage/index.vue